import CompanyForm from '@/components/companies/forms/CompanyForm';
import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetCompanyDetails } from '@/hooks/requests/useCompanies';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function CompanyEditPage() {
  const { uuid = '' } = useParams();
  const navigate = useNavigate();
  const { companyDetails, isCompanyDetailsLoading } =
    useGetCompanyDetails(uuid);

  if (isCompanyDetailsLoading) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!companyDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retrieving the company. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={`Edit ${companyDetails.name}`}
      breadcrumb={[
        { label: 'Companies', href: ROUTES.COMPANIES },
        {
          label: companyDetails.name,
          href: `${ROUTES.COMPANIES}/${uuid}`,
        },
        { label: 'Edit', isActive: true },
      ]}>
      <CompanyForm
        isEdit
        defaultValues={{
          uuid,
          name: companyDetails.name,
          brandingThemeId: companyDetails.brandingTheme.uuid,
          lendingEnabled: companyDetails.lendingEnabled,
          advisorOfficeType: companyDetails.advisorOfficeType,
          relationshipManagerId: companyDetails.relationshipManager.uuid,
          teammateCreatePerm:
            companyDetails.teammatePerms?.includes(0) || false,
          teammateUpdatePerm:
            companyDetails.teammatePerms?.includes(1) || false,
          teammateDeactivateReactivatePerm:
            companyDetails.teammatePerms?.includes(2) || false,
          divisionCreatePerm: false,
          divisionUpdatePerm: false,
          divisionDeletePerm: false,
          rateSavingInterest: companyDetails.rateSavingInterest,
          minimumInitDeposit: companyDetails.minimumInitDeposit
            ? companyDetails.minimumInitDeposit.value.toString()
            : '0',
          alias: companyDetails.alias,
          feeIncomingDomestic: companyDetails.feeIncomingDomestic
            ? companyDetails.feeIncomingDomestic.value.toString()
            : '0',
          feeOutcomeDomestic: companyDetails.feeOutcomeDomestic
            ? companyDetails.feeOutcomeDomestic.value.toString()
            : '0',
          feeMonthlySavingAccount: companyDetails.feeMonthlySavingAccount
            ? companyDetails.feeMonthlySavingAccount.value.toString()
            : '0',
          useProgramIncomingWireFee: !companyDetails.feeIncomingDomestic,
          useProgramOutgoingWireFee: !companyDetails.feeOutcomeDomestic,
          useProgramMonthlySavingsFee: !companyDetails.feeMonthlySavingAccount,
          debitCardProgramId: '',
        }}
        onSuccess={() => navigate(`${ROUTES.COMPANIES}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
